import { Button, Group, Stack, Text, Title } from '@mantine/core'

import type { PaymentMethod, Plan } from '@/services/api/api.types'
import { getPaymentMethodDescription } from '@/utils/paymentMethodHelpers'

import { BillingPlanCard } from './BillingPlanCard'

interface CreditPurchasePlanSelectionProps {
  plans: Plan[]
  selectedPlan: string
  onPlanSelect: (planId: string) => void
  onPurchase: () => void
  onCancel: () => void
  isUpdating?: boolean
  paymentMethod: PaymentMethod | null
}

export function CreditPurchasePlanSelection({
  plans,
  selectedPlan,
  onPlanSelect,
  onPurchase,
  onCancel,
  isUpdating = false,
  paymentMethod,
}: CreditPurchasePlanSelectionProps) {
  return (
    <Stack gap="xl">
      <Stack gap="xs" align="center">
        <Title order={3} ta="center">
          Purchase Credits
        </Title>
        <Text size="sm" c="dimmed" ta="center">
          <strong>1 credit per user request</strong>
        </Text>
        <Text size="sm" c="dimmed" ta="center">
          Choose a credit package for immediate use
        </Text>
      </Stack>

      {/* Plan Cards */}
      <Group
        justify="center"
        align="stretch"
        gap="xs"
        w="100%"
        mx="auto"
        style={{
          flexWrap: 'wrap',
        }}>
        {plans
          ?.filter(plan => plan.active)
          .sort((a, b) => a.priceDollars - b.priceDollars)
          .map(plan => (
            <BillingPlanCard
              key={plan.bundleId}
              plan={plan}
              isSelected={selectedPlan === plan.bundleId}
              onSelect={onPlanSelect}
              disabled={false}
            />
          ))}
      </Group>

      {paymentMethod && (
        <Text size="sm" c="dimmed" ta="center">
          Credits will be charged to {getPaymentMethodDescription(paymentMethod)}
        </Text>
      )}

      {/* Action Buttons */}
      <Group justify="space-between" mt="xl">
        <Button variant="light" onClick={onCancel} size="md" disabled={isUpdating}>
          Cancel
        </Button>
        <Button
          onClick={onPurchase}
          disabled={!selectedPlan || isUpdating}
          loading={isUpdating}
          size="md"
          color="indigo">
          {paymentMethod ? 'Purchase Credits' : 'Continue to Payment'}
        </Button>
      </Group>
    </Stack>
  )
}
